import React, {ReactNode} from 'react';

import Grid from '@material-ui/core/Grid';
import {useTranslation} from 'react-i18next';

import {ContentColumnsData, ContentColumnsProps, Map} from '../index';

import {ContentColumnElement, ContentColumnText, ContentColumnTitle} from './styled';

const renderItem = (obj: Map, tNameSpace?: string, md: ContentColumnsProps['md'] = 4) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {t} = useTranslation();
    const elements = Object.keys(obj).map((key: string, index: number) => (
        <ContentColumnElement key={index}>
            <ContentColumnTitle>{tNameSpace ? t(`${tNameSpace}.${key}`) : key}</ContentColumnTitle>
            <ContentColumnText highlighted>{obj[key]}</ContentColumnText>
        </ContentColumnElement>
    ));
    return (
        <Grid item xs={12} md={md}>
            {elements}
        </Grid>
    );
};

const renderItems = (
    elements: ContentColumnsData,
    tNameSpace?: string,
    md?: ContentColumnsProps['md'],
): ReactNode =>
    Array.isArray(elements)
        ? elements.map((el: ContentColumnsData) => {
              if (Array.isArray(el)) return renderItems(el, tNameSpace, md);
              return renderItem(el, tNameSpace, md);
          })
        : renderItem(elements, tNameSpace, md);

export const ContentColumns = (props: ContentColumnsProps) => {
    const {tNameSpace, data, md = 4} = props;
    return <Grid container>{renderItems(data, tNameSpace, md)}</Grid>;
};
